import { COLORS, SIZES } from 'src/styles/theme'
import styled from 'styled-components'

export const LoginPageStyle = styled.section`
  position: fixed;
  bottom: 25vh;
  right: 0vw;
  padding: 4vw;
  padding-top: 0;
  padding-right: 2vw;
  max-height: 100%;
  text-align: center;
  color: white;

  .action-text {
    font-weight: bold;
    color: #ff9821;
    cursor: pointer;
  }

  form {
    background: #fff;
    color: #404040;
    padding: 30px 10px;
    border-radius: 28px;
    margin: auto;
    margin-top: 30px;
    width: 30vw;
    max-width: 475px;

    input {
      width: 80%;
      background: ${COLORS.lightGray};
      border: none;
      padding: 12px 28px;
      border-radius: 20px;
      margin-top: 20px;

      &::placeholder {
        color: ${COLORS.lightGray1};
      }
    }

    .forget-pass {
      width: 80%;
      color: ${COLORS.primaryTrans};
      margin-top: 10px;
      font-size: 0.9em;
    }

    .login-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto;
      margin-top: 1em;
      margin-bottom: 0em;
      border-radius: 50%;
      letter-spacing: 1px;
      background: linear-gradient(#f5ba18, #d00937);
      width: 60px;
      height: 60px;
      cursor: pointer;
      opacity: 1;
      outline: none;
      border: none;
      input {
        cursor: pointer;
        opacity: 0;
        padding: 0;
        margin: 0;
        display: none;
      }
    }
    .title {
      font-weight: 500;
      font-size: 20px;
      margin: 0;
      color: #404040;
    }
    .white-arrow {
      width: 24px;
      line-height: 60px;
      cursor: pointer;
    }
  }

  div.privacy {
    margin: 0 auto;
    width: 90%;
    margin-top: 12px;

    .readMore {
      cursor: pointer;
      &:hover {
        opacity: .8;
      }
    }
  }
  .form-check {
    display: flex;
    align-items: flex-start;
    padding: 0;
    font-weight: 500;
    .agree-box {
      padding: 8px;
      margin-top: 4px;
      width: 20%;
    }
    .form-check-label {
      color: #404040;
      font-size: 11px;
      margin-left: 8px;
      a {
        text-decoration: underline;
      }
    }
  }

  #support-link {
    font-size: 11px;
    text-decoration: underline;
  }

  ${SIZES.mobile} {
    position: static;
    padding: 3vw;
    padding-top: 0;

    form {
      margin-top: 0px;
      width: inherit;
      border-radius: 10px;
    }
  }
`
